import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.lastResult;

const getMatchesLastResult = createSelector(getData, lastResult => lastResult);

export default getMatchesLastResult;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getMatchesLastResult.js